import React from 'react'
import type { Icon } from 'shared/utils'

export const BlazonBackground = (props: Icon) => {
    const {
        color = 'black',
        size = 17,
        className = 'blazon-container',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 17 19"
            {...otherProps}>
            <path
                d="M15.693 13.546l-6.36 4.329a1.11 1.11 0 01-1.248 0l-6.36-4.33a1.11 1.11 0 01-.486-.916V1.034A.362.362 0 00.964.682L.904.667h15.61l-.047.012a.38.38 0 00-.288.369v11.581c0 .367-.182.71-.486.917z"
                fill="#F5EBDC"
            />
        </svg>
    )
}
